import { PlateElement, withRef } from "@udecode/plate/react";
import {
  useTableElement,
  useTableCellElement,
  TableProvider,
} from "@udecode/plate-table/react";
// Remove ResizeHandle import for now to avoid dependency issues
import { cn } from "@/lib/utils";

// Main Table Element with provider
export const TableElement = withRef<typeof PlateElement>(
  ({ children, ...props }, ref) => {
    const { props: tableProps } = useTableElement();

    return (
      <TableProvider>
        <div className="my-4 overflow-x-auto">
          <PlateElement
            ref={ref}
            as="table"
            className={cn(
              "w-full border-collapse border border-border",
              "table-fixed",
            )}
            {...tableProps}
            {...props}
          >
            <tbody>{children}</tbody>
          </PlateElement>
        </div>
      </TableProvider>
    );
  },
);

// Table Row Element
export const TableRowElement = withRef<typeof PlateElement>(
  ({ children, ...props }, ref) => {
    return (
      <PlateElement
        ref={ref}
        as="tr"
        className="border-b border-border"
        {...props}
      >
        {children}
      </PlateElement>
    );
  },
);

// Table Cell Element
export const TableCellElement = withRef<typeof PlateElement>(
  ({ children, ...props }, ref) => {
    const { borders, selected, width } = useTableCellElement();

    return (
      <PlateElement
        ref={ref}
        as="td"
        className={cn(
          "border border-border px-3 py-2 text-left",
          "min-w-[48px] min-h-[32px]",
          selected && "bg-blue-50 ring-1 ring-blue-300",
        )}
        style={{
          width,
          ...(borders as React.CSSProperties),
        }}
        {...props}
      >
        {children}
      </PlateElement>
    );
  },
);

// Table Header Cell Element
export const TableCellHeaderElement = withRef<typeof PlateElement>(
  ({ children, ...props }, ref) => {
    const { selected } = useTableCellElement();

    return (
      <PlateElement
        ref={ref}
        as="th"
        className={cn(
          "border border-border px-3 py-2 text-left font-semibold",
          "min-w-[48px] min-h-[32px] bg-muted/50",
          selected && "bg-blue-100 ring-1 ring-blue-300",
        )}
        {...props}
      >
        {children}
      </PlateElement>
    );
  },
);
